import Vue from 'vue';
import Router from 'vue-router';
import AppLayout from '@/layouts/app-layout/app-layout.vue';
import AppHeaderLayout from '@/layouts/app-header-layout/app-header-layout.vue';
import { sessionService, SessionService } from '@/providers/services/auth/session';
import access from '@/permission/permission';
import 'pace-progressbar';
import * as LoginPage from 'navigator-widget-ui-component';

Vue.use(Router);

const routes = [
  {
    path: '/',
    redirect: 'projects',
    component: AppHeaderLayout,
    children: [
      {
        path: '/learners',
        name: 'learners',
        component: () => import('@/routers/views/learners/learners.vue'),
        meta: {isRequiredAuth: true, permission: 'learners'},
      },
      {
        path: '/report-data',
        name: 'report-data',
        component: () => import('@/routers/views/report-data/report-data.vue'),
        meta: {isRequiredAuth: true, permission: 'learners'},
      },
      {
        path: '/learners/:id',
        name: 'learners-proficiency',
        component: () => {
           // this need to move view
          return import('@/components/proficiency/learner-facets-proficiency/learner-facets-proficiency.vue');
        },
        meta: { isRequiredAuth: true},
      },
      {
        path: '/projects',
        name: 'research',
        component: () => import('@/routers/views/research/research.vue'),
        meta: {isRequiredAuth: true},
      },
      {
        path: '/publications',
        name: 'publications',
        component: () => import('@/routers/views/publications/publications.vue'),
        meta: {isRequiredAuth: true, permission: 'learners'},
      },
      {
        path: '/showcase',
        name: 'showcase-page',
        component: () => import('@/routers/views/showcase/showcase.vue'),
        meta: {isRequiredAuth: true},
      },
      {
        path: 'ai-playground',
        name: 'ai-playground',
        component: () => import('@/routers/views/ai-playground/ai-playground.vue'),
        meta: {isRequiredAuth: true, permission: 'learners'},
        children: [
          {
            path: '',
            name: 'ai-playground-dashboard',
            component: () => import('@/routers/views/ai-playground/ai-landing-page/ai-landing-page.vue'),
            meta: {isRequiredAuth: true, permission: 'learners'},
          },
          {
            path: 'generate',
            name: 'ai-playground-generator',
            component: () => import('@/routers/views/ai-playground/ai-generator-panel/ai-generator-panel.vue'),
            meta: {isRequiredAuth: true, permission: 'learners'},
          },
        ],
      },
      {
        path: '/showcase-revamp',
        name: 'showcase-revamp-page',
        component: () => import('@/routers/views/showcase-revamp/showcase-revamp.vue'),
        meta: {isRequiredAuth: true},
        children: [
          {
            path: '',
            name: 'showcase-landing-page',
            component: () => import('@/routers/views/showcase-revamp/showcase-facets/showcase-facets.vue'),
          },
          {
            path: 'marker-detail',
            name: 'showcase-landing-page',
            component: () => import('@/routers/views/showcase-revamp/facet-detail-view/facet-detail-view.vue'),
          },
        ],
      },
    ],
  },
  {
    path: '/',
    redirect: 'login',
    component: AppLayout,
    children: [
      ...LoginPage.routerList(),
      {
        path: '/logout',
        name: 'logout',
        beforeEnter() {
          sessionService.deleteSession();
          window.location.href = '/login';
        },
      },
    ],
  },
];

const router = new Router({
  linkExactActiveClass: 'active',
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior: (to, from, savedPosition) => {
    return new Promise((resolve, reject) => {
      setTimeout(() => {
        resolve({ x: 0, y: 0 });
      }, 500);
    });
  },
});


router.beforeEach((to, from, next) => {
  // Set the document title dynamically
  const isMyGooruHost = window.location.host.includes('mygooru.ai');
  document.title = `${isMyGooruHost ? 'MyGooru Research' : 'Research'}`;
  if (to.meta && to.meta.isRequiredAuth && !sessionService.isAuthorized()) {
    return next({ path: '/login', query: { redirect: to.fullPath } });
  } else if (to.meta && to.meta.permission &&  !access.hasMenuAccess(to.meta.permission)) {
    return next({path: `/${access.landingPage()}`});
  }
  next();
});

export default router;
